import cleanUpResponse from '@/util/cleanUpResponse';

export default async function GetCustomerOrderAttachmentDataByOrderID(orderId) {
  const response = await $.soap({
    body: {
      GetCustomerOrderAttachmentDataByOrderID: {
        $xmlns: 'http://dla.mil/ems/db/order/customer_order_attachment_data',
        OrderID: orderId
      }
    },
    blueprint: {
      id: '$..ID',
      fundingTypeID: '$..FundingDocumentTypeID',
      gInvoicingOrderNumber: '$..GInvoicingOrderNumber',
      fundingAmount: '$..FundingAmount',
      noFundingExplanation: '$..NoFundingExplanation',
      updatedBy: '$..UpdatedBy',
      updatedOn: '$..UpdatedOn',
      additionalDocumentsRequired: '$..HasAdditionalAttachments'
    }
  });

  cleanUpResponse(response);
  return response;
}
